import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils';

import { type DeliveryNotesAdminQueryParameters } from '../useQueryDeliveryNotesAdmin/types';
import { zodDeliveryNotesAdminQueryParametersSchema } from '../useQueryDeliveryNotesAdmin/validations';

import { type DeliveryNotesCountAdminResponse } from './types';

/**
 * Fetches the total count of Delivery Notes from the server that match the given filter configuration.
 *
 * @param queryParameters - Query parameters including filters, pagination, and sorting.
 * @returns the count of Delivery Notes.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Asset/operation/search_delivery_note_count_vadmin_asset_delivery_note_search_count_post
 */
export const fetchDeliveryNotesCountAdmin = async (
  queryParameters: DeliveryNotesAdminQueryParameters,
  options?: KyRequestOptions,
) => {
  try {
    const response = await vestigasApi
      .post(ENDPOINT.DELIVERY.GET_COUNT_ADMIN(), {
        json: queryParameters,
        validate: { body: zodDeliveryNotesAdminQueryParametersSchema },
        ...options,
      })
      .json<DeliveryNotesCountAdminResponse>();

    return response;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      // Re-throw AbortError without logging as it's expected when requests are cancelled
      throw error;
    }

    log.error({
      message: 'Error fetching Delivery Notes Count Admin',
      error,
    });

    // Do not show an error message as we are only using this request in combination with the getAll request,
    // which would already show the error message.

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
